import React from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";

import { Link } from "react-router-dom";

const ClassesList = ({ data, query }) => {
  const columns = [
    { path: "id", label: "شماره" },

    { path: "subject_code", label: "کد مضمون" },
    { path: "subject_name", label: "مضمون" },
    { path: "department", label: "دیپارتمنت" },
    { path: "faculty", label: "پوهنحی" },
    { path: "credits", label: "تعداد کریدت" },
    {
      path: "option",
      content: (e) => <Option Edit={{ form: "subject-form", edit: e }} />,
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default ClassesList;
